import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const ABOUT_IMG = "/images/titanium-city-centre.png";

const Stat = ({ value, label, gu }) => (
    <div className="bg-white border-l-4 border-[#0B308A] p-5 shadow-sm">
        <div className="font-display text-3xl font-bold text-slate-900">{value}</div>
        <div className={`text-[13px] text-slate-500 mt-1 ${gu}`}>{label}</div>
    </div>
);

const About = () => {
    const { lang, t } = useLanguage();
    const gu = lang === "gu" ? "font-gujarati" : "";
    const bullets = [
        "Vehicle, car & commercial vehicle loans across Gujarat",
        "Home loans tailored for Ahmedabad",
        "Loan against property & mortgage solutions",
        "Comprehensive vehicle insurance support",
    ];
    const bulletsGu = [
        "ગુજરાતભરમાં વાહન, કાર અને કોમર્શિયલ વાહન લોન",
        "અમદાવાદ માટે ખાસ હોમ લોન",
        "મિલકત સામે લોન અને મોર્ગેજ સોલ્યુશન્સ",
        "વ્યાપક વાહન વીમા સહાય",
    ];
    const list = lang === "gu" ? bulletsGu : bullets;

    return (
        <section
            id="about"
            data-testid="about-section"
            className="py-24 md:py-32 bg-white relative"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                {/* Image */}
                <div className="lg:col-span-5 relative">
                    <div className="absolute -top-5 -left-5 w-28 h-28 bg-[#0B308A]/10 rounded-sm -z-10" />
                    <div className="absolute -bottom-5 -right-5 w-28 h-28 border-2 border-[#FACC15] rounded-sm -z-10" />
                    <div className="relative overflow-hidden rounded-sm shadow-[0_20px_50px_rgba(11,48,138,0.15)]">
                        <img
                            src={ABOUT_IMG}
                            alt="Trusted financial advisory"
                            loading="lazy"
                            className="w-full h-[480px] object-cover"
                        />
                        <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-[#0B308A]/70 via-transparent to-transparent p-5 text-white">
                            <div className="text-[10px] uppercase tracking-[0.22em] font-semibold opacity-80">
                                Est. {2019}
                            </div>
                            <div className="font-display font-semibold text-lg">
                                Ahmedabad, Gujarat
                            </div>
                        </div>
                    </div>
                </div>

                {/* Text */}
                <div className="lg:col-span-7">
                    <span
                        className={`inline-block text-[11px] uppercase tracking-[0.22em] font-semibold text-[#0B308A] ${gu}`}
                    >
                        {t("about.overline")}
                    </span>
                    <h2
                        className={`mt-4 text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-slate-900 leading-[1.1] ${gu}`}
                    >
                        {t("about.title")}
                    </h2>
                    <p className={`mt-6 text-slate-600 leading-relaxed text-[17px] ${gu}`}>
                        {t("about.p1")}
                    </p>
                    <p className={`mt-4 text-slate-600 leading-relaxed text-[17px] ${gu}`}>
                        {t("about.p2")}
                    </p>

                    <ul className="mt-7 space-y-3">
                        {list.map((b, i) => (
                            <li
                                key={i}
                                className={`flex items-start gap-3 text-slate-800 ${gu}`}
                            >
                                <CheckCircle2 className="w-5 h-5 text-[#0B308A] mt-0.5 shrink-0" />
                                <span className="text-[15px]">{b}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-3">
                        <Stat value="7+" label={t("about.stat1_label")} gu={gu} />
                        <Stat value="5k+" label={t("about.stat2_label")} gu={gu} />
                        <Stat value="25+" label={t("about.stat3_label")} gu={gu} />
                        <Stat value="98%" label={t("about.stat4_label")} gu={gu} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
